import React from 'react'
import { useState } from 'react'
import { Card, Col, Flex, Row, } from 'antd'
import { CardComponent, ModuleTopHeading, Projecttable} from '../../components'

const Dashboard = () => {
  return (
      <div>
        <Row gutter={[16,16]}>
          <Col span={24}>
            <CardComponent />
          </Col>
          <Col span={24}>
            <Card className='shadow-d radius-12'>
              <Row gutter={[24, 24]}>
                <Col span={24}>
                  <Flex vertical gap={20}>
                    <ModuleTopHeading level={4} name='Projects'/>
                  </Flex>
                </Col>
                <Col span={24}>
                  <Projecttable />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
  )
}

export {Dashboard}